import { Component, Fragment, h, Prop, State, Watch } from '@stencil/core';
import { Translations } from '../../../../../redux/types';
import { ComponentView, Filters, SortByOptions, SortDirOptions } from '../../../../../types/types';
import { trans } from '../../../../../utils/trans';
import { capitalizeFirstLetter } from '../../../../../utils/utils';
import SortIcon from '../../../../atoms/svg-elements/sort-icon';
import { SearchParameters } from '../../../utils';

@Component({
    tag: 'rentware-search-filters-sort',
    shadow: false,
})
export class RentwareSearchFiltersSort {
    @Prop() translations: Translations;
    @Prop() locale: string;
    @Prop() onSortChange: (any) => void = () => { };
    @Prop() shownFilters: Filters[];
    @Prop() onFilterAccordionClick: (Filters) => void;
    @Prop() changedSortBy: SortByOptions;
    @Prop() changedSortDir: SortDirOptions;
    @Prop() view: ComponentView;

    @State() selectedSortOption: SearchParameters = { sortBy: SortByOptions.Default, sortDir: SortDirOptions.Asc };

    @Watch('changedSortBy')
    changeSortBy() {
        this.selectedSortOption = { ...this.selectedSortOption, sortBy: this.changedSortBy };
    }

    @Watch('changedSortDir')
    changeSortDir() {
        this.selectedSortOption = { ...this.selectedSortOption, sortDir: this.changedSortDir };
    }

    get label() {
        return (
            <span>
                {SortIcon}
                {trans('search.sortBy', this.locale, this.translations)}
            </span>
        )
    }

    getTranslatedSortOption = (option) => {
        return trans('search.sort' + capitalizeFirstLetter(option), this.locale, this.translations);
    }

    handleOptionCLick = (option) => {
        this.selectedSortOption = { ...this.selectedSortOption, ...option };
        this.onSortChange(this.selectedSortOption);
    }

    handleAccordionClick = () => {
        this.onFilterAccordionClick(Filters.Sort);
    }

    makeSortByOption = (option) => {
        if (!(option === SortByOptions.Price && this.view === ComponentView.Slots)) {
            return (
                <Fragment>
                    <label>
                        <rentware-radio
                            name="filterBySortOption"
                            label={this.getTranslatedSortOption(option)}
                            value={option}
                            checked={this.selectedSortOption.sortBy === option}
                            onClick={() => this.handleOptionCLick({ sortBy: option })}
                        />
                    </label>

                    <rentware-spacer size="S" />
                </Fragment>
            )
        }
    }

    makeSortDirOption = (option) => {
        return (
            <Fragment>
                <label>
                    <rentware-radio
                        name="filterDirSortOption"
                        label={this.getTranslatedSortOption(option)}
                        value={option}
                        checked={this.selectedSortOption.sortDir === option}
                        onClick={() => this.handleOptionCLick({ sortDir: option })}
                    />
                </label>

                <rentware-spacer size="S" />
            </Fragment>
        )
    }

    get sortByOptions(): string[] {
        const options = [];

        Object.values(SortByOptions).map(value => {
            options.push(value);
        })

        return options;
    }

    get sortDirOptions(): string[] {
        const options = [];

        Object.values(SortDirOptions).map(value => {
            options.push(value);
        })

        return options;
    }

    render() {
        return (
            <rentware-search-filters-accordion
                label={this.label}
                additionalInfo={this.getTranslatedSortOption(this.selectedSortOption.sortBy)}
                opened={this.shownFilters.includes(Filters.Sort)}
                onAccordionClick={this.handleAccordionClick}
            >
                <div class="FiltersSortContainer">
                    {this.sortByOptions.map((option) => this.makeSortByOption(option))}
                </div>

                <rentware-spacer size="M" />

                <div class="FiltersSortContainer">
                    {this.sortDirOptions.map((option) => this.makeSortDirOption(option))}
                </div>
            </rentware-search-filters-accordion>
        )
    }
}
